/**
 * Animation timing design tokens
 */
export const AnimationTokens = {
    duration: {
        instant: 0,
        fast: 150,
        normal: 300,
        slow: 500,
    },

    easing: {
        linear: "Linear",
        easeIn: "Quad.easeIn",
        easeOut: "Quad.easeOut",
        easeInOut: "Quad.easeInOut",
    },
};
